<template>
  <section class="o-hero" :class="$mq">
    <div class="o-container o-container--xlarge u-center-block">
      <div class="o-hero__content">
        <h2 class="c-heading u-super">{{ title }}</h2>
        <p class="o-hero__subtitle">{{ subTitle }}</p>
        <bos-button :class="'btn-white'">
          {{ buttonLabel }}
        </bos-button>
      </div>
      <button class="o-hero__close" @click="closeHero()">
        <img src="../assets/images/icons/cross.svg" />
      </button>
    </div>
  </section>
</template>

<script>
import BosButton from '../components/BosButton'

export default {
  name: 'BosHero',
  components: {
    BosButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    closeHero: {
      type: Function
    },
    buttonLabel: {
      type: String,
      degault: ''
    },
    buttonUrl: {
      type: String,
      default: '#'
    }
  }
}
</script>

<style lang="scss" scoped>
.o-hero {
  background-color: #2e9699;
  display: block;
  width: 100%;
  text-align: center;
  color: #f7f6f3;

  .o-container {
    padding: 60px 20px 80px;
    min-height: 440px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .u-super {
    font-size: 45px;
    padding-top: 0;
    padding-bottom: 5px;
    font-weight: 300;
  }

  &__content {
    position: relative;
    max-width: 600px;
  }

  &__subtitle {
    font-size: 21px;
    margin-top: 0;
    font-weight: 300;
  }

  &__close {
    cursor: pointer;
    top: 20px;
    right: 20px;
    position: absolute;
    border: 0;
    padding: 0;
    background-color: transparent;
  }

  &.md,
  &.sm,
  &.xs {
    .u-super {
      font-size: 36px;
      line-height: 1.11;
    }
  }

  &.sm,
  &.xs {
    .c-button {
      width: 100%;
    }
  }
}
</style>
